// Custom template for search page
document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function (_defaultTemplate, data, html) {
    const mediaQuery = window.matchMedia('(min-width: 990px)')
    return html`<div class="ais-page">
        <div class="search-page-header">
          <h1 class="ais-h2" id="header-stats"></h1>
          <div class="ais-input">
            <div class="ais-search-box-container"></div>
            <div class="ais-input-button">
              <div class="ais-clear-input-icon"></div>
            </div>
          </div>
        </div>
        
        <div class="ais-facets ais-facets--desktop">
          <div class="ais-facets-heading">Filters</div>
        
          
          ${mediaQuery.matches && data.facets.map(facet =>
      html`<div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
          <input class="ais-dropdown-checkbox" type="checkbox" id="${facet.escapedName}" name="dropdown" />
              <label for="${facet.escapedName}" class="ais-range-slider--header ais-facet--header ais-header">${facet.title}<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.6932 6.25704C2.88846 6.06178 3.20504 6.06178 3.40031 6.25704L8.04675 10.9035L12.6932 6.25704C12.8885 6.06178 13.205 6.06178 13.4003 6.25704C13.5956 6.4523 13.5956 6.76889 13.4003 6.96415L8.40031 11.9641C8.20504 12.1594 7.88846 12.1594 7.6932 11.9641L2.6932 6.96415C2.49794 6.76889 2.49794 6.4523 2.6932 6.25704Z" fill="black"/>
              </svg></label>
              <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
            </div>`
    )}
        <div class="delta-instantsearch-results-wrap" id="delta-instantsearch-results-wrap">
          <h3>Pages</h3>
          <div class="delta-instantsearch-results delta-pages-search-results"></div>
          <h3>Articles</h3>
          <div class="delta-instantsearch-results delta-posts-search-results"></div>
        </div><!-- .delta-search-results -->
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-facets-button-wrap">
              <div class="ais-facets-button">
                Filter & Sort
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M3 16.125C3 15.7108 3.33579 15.375 3.75 15.375H12.75C13.1642 15.375 13.5 15.7108 13.5 16.125C13.5 16.5392 13.1642 16.875 12.75 16.875H3.75C3.33579 16.875 3 16.5392 3 16.125Z" fill="black"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M15 16.125C15 15.7108 15.3358 15.375 15.75 15.375H20.25C20.6642 15.375 21 15.7108 21 16.125C21 16.5392 20.6642 16.875 20.25 16.875H15.75C15.3358 16.875 15 16.5392 15 16.125Z" fill="black"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M3 7.875C3 7.46079 3.33579 7.125 3.75 7.125H6.75C7.16421 7.125 7.5 7.46079 7.5 7.875C7.5 8.28921 7.16421 8.625 6.75 8.625H3.75C3.33579 8.625 3 8.28921 3 7.875Z" fill="black"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9 7.875C9 7.46079 9.33579 7.125 9.75 7.125H20.25C20.6642 7.125 21 7.46079 21 7.875C21 8.28921 20.6642 8.625 20.25 8.625H9.75C9.33579 8.625 9 8.28921 9 7.875Z" fill="black"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75 4.875C10.1642 4.875 10.5 5.21079 10.5 5.625V10.125C10.5 10.5392 10.1642 10.875 9.75 10.875C9.33579 10.875 9 10.5392 9 10.125V5.625C9 5.21079 9.33579 4.875 9.75 4.875Z" fill="black"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.75 13.125C16.1642 13.125 16.5 13.4608 16.5 13.875V18.375C16.5 18.7892 16.1642 19.125 15.75 19.125C15.3358 19.125 15 18.7892 15 18.375V13.875C15 13.4608 15.3358 13.125 15.75 13.125Z" fill="black"/>
                </svg>
              </div>
              <div class="ais-change-display">
                <span class="ais-change-display-block ais-change-display-selected"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.375 4.875C3.375 4.04657 4.04657 3.375 4.875 3.375H19.125C19.9534 3.375 20.625 4.04657 20.625 4.875V19.125C20.625 19.9534 19.9534 20.625 19.125 20.625H4.875C4.04657 20.625 3.375 19.9534 3.375 19.125V4.875ZM19.125 4.875H4.875V19.125H19.125V4.875Z" fill="black"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M12 3.375C12.4142 3.375 12.75 3.71079 12.75 4.125V19.875C12.75 20.2892 12.4142 20.625 12 20.625C11.5858 20.625 11.25 20.2892 11.25 19.875V4.125C11.25 3.71079 11.5858 3.375 12 3.375Z" fill="black"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M3.375 12C3.375 11.5858 3.71079 11.25 4.125 11.25H19.875C20.2892 11.25 20.625 11.5858 20.625 12C20.625 12.4142 20.2892 12.75 19.875 12.75H4.125C3.71079 12.75 3.375 12.4142 3.375 12Z" fill="black"></path></svg></span>
                <span class="ais-change-display-list "><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 6C7.5 5.58579 7.83579 5.25 8.25 5.25H20.25C20.6642 5.25 21 5.58579 21 6C21 6.41421 20.6642 6.75 20.25 6.75H8.25C7.83579 6.75 7.5 6.41421 7.5 6Z" fill="black"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 12C7.5 11.5858 7.83579 11.25 8.25 11.25H20.25C20.6642 11.25 21 11.5858 21 12C21 12.4142 20.6642 12.75 20.25 12.75H8.25C7.83579 12.75 7.5 12.4142 7.5 12Z" fill="black"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 18C7.5 17.5858 7.83579 17.25 8.25 17.25H20.25C20.6642 17.25 21 17.5858 21 18C21 18.4142 20.6642 18.75 20.25 18.75H8.25C7.83579 18.75 7.5 18.4142 7.5 18Z" fill="black"></path><path d="M4.125 7.125C4.74632 7.125 5.25 6.62132 5.25 6C5.25 5.37868 4.74632 4.875 4.125 4.875C3.50368 4.875 3 5.37868 3 6C3 6.62132 3.50368 7.125 4.125 7.125Z" fill="black"></path><path d="M4.125 13.125C4.74632 13.125 5.25 12.6213 5.25 12C5.25 11.3787 4.74632 10.875 4.125 10.875C3.50368 10.875 3 11.3787 3 12C3 12.6213 3.50368 13.125 4.125 13.125Z" fill="black"></path><path d="M4.125 19.125C4.74632 19.125 5.25 18.6213 5.25 18C5.25 17.3787 4.74632 16.875 4.125 16.875C3.50368 16.875 3 17.3787 3 18C3 18.6213 3.50368 19.125 4.125 19.125Z" fill="black"></path></svg></span>
              </div>
            </div>
            <div class="ais-sort ais-sort--desktop">
              ${mediaQuery.matches && data.multipleSortOrders ?
        html`${algoliaShopify.translations.sortBy} <span class="ais-sort-orders-container"></span>`
        : html`${algoliaShopify.translations.sortBy} ${algoliaShopify.translations.relevance}`
      }
            </div>
          </div>
          <div class="ais-custom-applied-filters">
            <div class="ais-current-refined-values-container"></div>
            <div class="ais-clear-refinements-container"></div>
          </div>
          <div class="ais-facets ais-facets--mobile">
            <div class="ais-sort ais-sort--mobile">
              ${data.multipleSortOrders ?
        html`${algoliaShopify.translations.sortBy} <span class="ais-sort-orders-container"></span>`
        : html`${algoliaShopify.translations.sortBy} ${algoliaShopify.translations.relevance}`
      }
            </div>
            
            ${data.facets.map(facet =>
        html`<div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
              <input class="ais-dropdown-checkbox" type="checkbox" id="${facet.escapedName}--mobile" name="dropdown" />
                  <label for="${facet.escapedName}--mobile" class="ais-range-slider--header ais-facet--header ais-header">${facet.title}<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.6932 6.25704C2.88846 6.06178 3.20504 6.06178 3.40031 6.25704L8.04675 10.9035L12.6932 6.25704C12.8885 6.06178 13.205 6.06178 13.4003 6.25704C13.5956 6.4523 13.5956 6.76889 13.4003 6.96415L8.40031 11.9641C8.20504 12.1594 7.88846 12.1594 7.6932 11.9641L2.6932 6.96415C2.49794 6.76889 2.49794 6.4523 2.6932 6.25704Z" fill="black"/>
                  </svg></label>
                  <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                </div>`
      )}
            </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
        <div class="delta-instantsearch-results-wrap delta-instantsearch-results-wrap--mobile">
          <h3>Pages</h3>
          <div class="delta-instantsearch-results delta-pages-search-results--mobile"></div>
          <h3>Articles</h3>
          <div class="delta-instantsearch-results delta-posts-search-results--mobile"></div>
        </div><!-- .delta-search-results -->
      </div>`;
  });
});

// Update stat temple on search page
document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function (_defaultTemplate, data, html) {
    return html`${data.hasNoResults && ''}
        ${data.hasOneResult &&
      html`<span class="ais-stats--nb-results">
            ${window.algoliaShopify.translations.oneResultFound}
        </span>`}
        ${data.hasManyResults &&
      html`Results 
        ${window.algoliaShopify.translations.results}
        ${' '}
        ${window.algoliaShopify.translation_helpers.outOf(data.page, data.hitsPerPage, data.nbHits)}
        
          ${' '}
          ${window.algoliaShopify.helpers.formatNumber(data.nbHits)}
        `}`
  });
});



// Pull color variants images and show them on search page
function lhebounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}

const addColorVariantsToResults = lhebounce(function () {
  const resultItems = document.querySelectorAll('.ais-Hits-item .card-wrapper');

  resultItems.forEach(resultItem => {
    const productHandle = resultItem.dataset.productHandle;
    const colorVariantDiv = resultItem.querySelector('.color-variants');
    if (productHandle && colorVariantDiv) {
      fetch(`/products/${productHandle}/?view=color-variants`, {
        method: 'GET'
      })
        .then(response => response.text())
        .then(data => {
          colorVariantDiv.innerHTML = data;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    }
  });
}, 300);

document.addEventListener('algolia.instantSearch.onRender', function () {
  addColorVariantsToResults();
});

// Update product/hit tempalte
document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (_defaultTemplate, hit, html, components, trackSearchAttribution) {
    const hitImage = algoliaShopify.helpers.renderImage(hit, 250);
    const algolia = window.algoliaShopify;
    return html`<div class="ais-hit ais-product card-wrapper product-card-wrapper underline-links-hover" data-product-handle="${hit.handle}">
        <div class="card card--standard card--media" style="--ratio-percent: 100%;">
          <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 100%;">
          
              <div class="card__media">
                  <img
                    src="${algolia.helpers.originalImage(hit)}"
                    class="motion-reduce"
                    loading="lazy" />
              
              </div>
         
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading">
                  <a
                    data-algolia-index="${hit.index}"
                    data-algolia-position="${hit.productPosition}"
                    data-algolia-queryid="${hit.queryID}"
                    data-algolia-objectid="${hit.objectID}"
                    href="${algolia.helpers.instantsearchLink(hit)}"
                    onclick="void(0)"
                    title="${algolia.helpers.fullTitle(hit.title, hit._distinct, hit.variant_title)}"
                    class="full-unstyled-link"
                  >
                    ${algolia.helpers.fullTitle(hit.title, hit._distinct, hit.variant_title)}
              
                  </a>
                </h3>
              </div>
            </div>
          </div>
          <div class="card__content">
            <div class="card__information">
              <h3 class="card__heading h5">
                <a
                  class="full-unstyled-link"
                  data-algolia-index="${hit.index}"
                  data-algolia-position="${hit.productPosition}"
                  data-algolia-queryid="${hit.queryID}"
                  data-algolia-objectid="${hit.objectID}"
                  href="${algolia.helpers.instantsearchLink(hit)}"
                  onclick="void(0)"
                  title="${algolia.helpers.fullTitle(hit.title, hit._distinct, hit.variant_title)}"
                >
                ${components.Highlight({ attribute: 'title', hit })}
          
                </a>
              </h3>
              <div class="card-information">
                ${((hit.template_suffix == null || !hit.template_suffix) && window.hideProductPrices == true) ? '' : html`<div class="price">
                  ${window.themeCore.searchHidePrice == false && algolia.helpers.displayPrice(hit, hit._distinct)}
                  ${window.themeCore.searchHidePrice == false && !hit._distinct && html`<span class="ais-hit--price-striked"><span>${algolia.helpers.displayStrikedPrice(hit.price, hit.compare_at_price)}</span></span>`}
                  ${window.themeCore.searchHidePrice == false && !hit._distinct && html`<span class="ais-hit--price-discount">${algolia.helpers.displayDiscount(hit.price, hit.compare_at_price, hit.price_ratio)}</span>`}
                </div>`}
                
                <div class="color-variants"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  });
});


// Adds articles and pages results to the search page
document.addEventListener('algolia.instantSearch.afterInit', function () {

  const { instantsearch, algoliasearch } = window.algoliaShopify.externals;
  const { item, hits, configure } = window.algoliaShopify.externals.widgets;

  const urlParams = new URLSearchParams(window.location.search);
  const searchQuery = urlParams.get('q');

  const pagesTempaltes = {
    item(hit, { html, components }) {
      return html`
        <a href="/pages/${hit.handle}">
          ${hit.title}
        </a>
      `;
    },
    empty: "No results",
  };

  const pagesSearch = instantsearch({
    indexName: window.algoliaShopify.config.index_prefix + 'pages',
    searchClient: algoliasearch(
      window.algoliaShopify.config.app_id,
      window.algoliaShopify.config.search_api_key
    ),
    searchParameters: {
      hitsPerPage: 6
    },
    searchFunction(helper) {
      helper.setQuery(searchQuery)
        .search();
    }
  });

  pagesSearch.addWidgets([
    hits({
      container: '.delta-pages-search-results',
      templates: pagesTempaltes,
    }),
    configure({
      hitsPerPage: 6,
    })
  ]);
  pagesSearch.addWidgets([
    hits({
      container: '.delta-pages-search-results--mobile',
      templates: pagesTempaltes,
    }),
    configure({
      hitsPerPage: 6,
    })
  ]);

  const postsTemplates = {
    item(hit, { html, components }) {
      return html`
        <a href="/blogs/${hit.blog.handle}/${hit.handle}">
          ${hit.title}
        </a>
      `;
    },
    empty: "No results",
  };


  const postsSearch = instantsearch({
    indexName: window.algoliaShopify.config.index_prefix + 'articles',
    searchClient: algoliasearch(
      window.algoliaShopify.config.app_id,
      window.algoliaShopify.config.search_api_key
    ),
    searchParameters: {
      hitsPerPage: 6
    },
    searchFunction(helper) {
      helper.setQuery(searchQuery)
        .search();
    }
  });
  postsSearch.addWidgets([
    hits({
      container: '.delta-posts-search-results',
      templates: postsTemplates,
    }),
    configure({
      hitsPerPage: 6,
    })
  ]);
  postsSearch.addWidgets([
    hits({
      container: '.delta-posts-search-results--mobile',
      templates: postsTemplates,
    }),
    configure({
      hitsPerPage: 6,
    })
  ]);


  postsSearch.start();

  pagesSearch.start();

});


// Add new stats widget and mobile show/hide facets button functionality
document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function () {
    const { stats } = window.algoliaShopify.externals.widgets;

    const init = {
      init: function () {
        var $button = document.querySelector('.ais-facets-button');
        $button.addEventListener('click', function () {
          var $facets = document.querySelectorAll('.ais-facets');
          $facets.forEach(el => {

            if (el.classList.contains('ais-facets__shown')) {
              // $button.textContent = 'Show filters';
              el.classList.remove('ais-facets__shown');
            } else {
              // $button.textContent = 'Hide filters';
              el.classList.add('ais-facets__shown');
            }
          });
        });
      },
    };
    const headerStats = stats({
      container: '#header-stats',
      templates: {
        text(data, { html }) {
          if (!data.query) {
            return 'Search'
          }
          if (data.hasOneResult) {
            return `${data.nbHits} result for "${data.query}"`
          }
          if (data.hasManyResults) {
            return `${data.nbHits} results for "${data.query}"`
          }
          if (data.hasNoResults && window.algoliaShopify.translations.noResultFound) {
            return '';
          }
        }
      },
    })

    return [init, headerStats];
  });
});
